/*
 * @Author: lijing
 * @Date: 2022-08-28 14:49:44
 * @Last Modified by: lijing
 * @Last Modified time: 2022-11-11 11:37:47
 */
import React, { Children, FC, useEffect, useState } from "react";
import {
  Form,
  Input,
  Select,
  Upload,
  Button,
  Switch,
  InputNumber,
  Modal,
  message,
  DatePicker,
} from "antd";
import moment from "moment";
import { useSelector } from "react-redux";
import { CheckVideo, IVideoProp } from "./checkVideo";
import {
  uploadFile,
  getBase64Image,
  selectTeacher,
  selectTag,
  uploadBase64Image,
  saveLive,
  querySpecialClassificationData,
  querySubjectTree,
  queryCategoryTree,
  getCourseDefaultImg,
} from "@root/common/service";
import E from "wangeditor";
import { RootState } from "@root/store";
import { handleTreelData } from "@root/common/utils";
const { Option } = Select;
const { TextArea } = Input;
const labelCol = { span: 3 };
const wrapperCol = { span: 20 };
const { RangePicker } = DatePicker;
interface IProps {
  liveDetail?: any;
  treeData: any[];
  getCourseList?: (page?: number, params?: object) => Promise<void>;
  setIseditorCourseVisible: React.Dispatch<React.SetStateAction<boolean>>;
}

interface ICourseSectionProp {
  id?: number;
  type: number;
  name: string;
  thirdVideoId: string;
  videoName: string;
}

interface OriginImageProps {
  shortUrl?: string;
  url?: string;
  initImage?: string;
}
let originalImage: OriginImageProps = {}; // 图片原始路径
let base64Image: string | null = null; // 图片原始路径
export const EditorLive: FC<IProps> = (props) => {
  const { liveDetail, treeData } = props;
  console.log("liveDetail", liveDetail);

  const [originalLogo, setOriginalLogo] = useState<string | undefined>();
  const [waterMark, setWaterMark] = useState<boolean>(true);
  const [replayFlag, setReplayFlag] = useState<boolean>(true);
  const [form] = Form.useForm();
  const [courseware] = Form.useForm();
  const handleOk = () => {
    postSaveCourse();
  };
  const handleCancel = () => {
    props.setIseditorCourseVisible(false);
  };

  /**
   * 上传图片
   * @param {object} 文件内容
   * @return void
   */
  const uploadChange = async (data: any) => {
    const { file } = data;

    if (
      file.type !== "image/jpeg" &&
      file.type !== "image/jpg" &&
      file.type !== "image/png"
    ) {
      message.error("请选择正确的文件");
      return false;
    }
    if (file.size / 1024 / 1024 > 2) {
      message.error("请选择正确的文件");
      return false;
    }

    let width = 0;
    let height = 0;

    const checkSize = function () {
      return new Promise((resolve, reject) => {
        let image = new Image();
        image.src = URL.createObjectURL(file);
        image.onload = function () {
          resolve({ width: image.width, height: image.height });
        };
      });
    };
    await checkSize()
      .then((res: any) => {
        width = res.width;
        height = res.height;
      })
      .catch((err) => {
        message.error("图片解析错误");
      });

    if (width !== 469 || height !== 300) {
      message.error("请上传宽469px、高300px的图片");
      return false;
    }

    let formData = new FormData();
    formData.append("file", file);
    formData.append("uploadFileType", "image");
    formData.append("folder", "course");

    uploadFile(formData).then((res) => {
      originalImage.shortUrl = res.url;
      originalImage.url = res.shortUrl;

      form.setFieldsValue({ image: res.url });
      getBase64Image(res.shortUrl).then((base) => {
        base64Image = base.data;
        setOriginalLogo(base.data);
        if (waterMark) {
          watermaskChange(true, base.data);
        }
      });
    });
  };

  /**
   * 水印修改
   * @param checked 水印是否打开
   * @param base64 图片base64数据
   * @returns void
   */
  const watermaskChange = async (checked: boolean, base64?: string) => {
    if (checked || base64) {
      const canvas = document.createElement("canvas");
      const ctx: CanvasRenderingContext2D | null = canvas.getContext("2d");

      if (ctx === null) return;

      const image: HTMLImageElement = new Image();
      image.src = base64 || (base64Image as string);
      image.onload = function () {
        canvas.width = image.width;
        canvas.height = image.height;

        ctx.drawImage(image, 0, 0);

        const text = form.getFieldsValue().name;
        if (text) {
          if (text.length > 10) {
            const len = Math.ceil(text.length / 10);
            // 初始位置 = （当前高度 - （行数 * （字高+行距）- 行距）） / 2
            // 微软雅黑实际测量 字高21px 行距5px；最后一行不需要行距
            const init = (image.height - (len * 26.5 - 5)) / 2;
            for (let i = 0; i < len; i++) {
              ctx.font = "normal bold 30px microsoft yahei";
              ctx.fillStyle = "#ffff";
              ctx.textAlign = "center";
              ctx.fillText(
                text.substr(i * 10, 10),
                image.width / 2,
                init + i * 40
              );
            }
          } else {
            ctx.font = "normal bold 30px microsoft yahei";
            ctx.fillStyle = "#ffff";
            ctx.textAlign = "center";
            ctx.textBaseline = "middle";
            ctx.fillText(text, image.width / 2, image.height / 2);
          }
        }

        setOriginalLogo(canvas.toDataURL("image/jpeg"));
      };
    } else {
      setOriginalLogo(originalImage.url);
    }
  };

  /**
   * 水印修改前触发
   * @param checked 水印是否打开
   */
  const watermaskChangeBefore = (checked?: boolean) => {
    const check = checked || waterMark;
    if (!check) return;

    // 如果base64图片存在 =》 直接修改； 否则转换base64文件
    if (base64Image) {
      watermaskChange(true);
    } else {
      // 判断是否存在原始图片
      if (originalImage.url) {
        getBase64Image(originalImage.url).then((base) => {
          base64Image = base.data;
          watermaskChange(true, base.data);
        });
      }
    }
  };

  /**
   * 课程名称修改触发
   */
  const onNameChange = () => {
    watermaskChangeBefore();
  };

  const postSaveCourse = () => {
    form
      .validateFields()
      .then(async (res) => {
        // 如果初始图片发生过修改则上传新的图片
        if (originalLogo !== originalImage.initImage) {
          let formData = new FormData();
          formData.append("base64Image", originalLogo as string);
          formData.append("folder", "course");
          await uploadBase64Image(formData).then((base) => {
            res.image = base.url;
          });
        }

        res.originalImage = originalImage?.shortUrl;

        // 如果为编辑
        if (liveDetail && liveDetail.id) {
          res.id = liveDetail.id;
        }
        const { liveTime } = res;
        let data = {
          ...res,
          waterMark: waterMark ? 1 : 0,
          replayFlag: replayFlag ? 1 : 0,
          startTime: moment(liveTime[0]).format("YYYY-MM-DD HH:mm:ss"),
          endTime: moment(liveTime[1]).format("YYYY-MM-DD HH:mm:ss"),
        };

        saveLive(data).then((res) => {
          message.success("保存成功");
          props.getCourseList && props.getCourseList();
          props.setIseditorCourseVisible(false);
        });
      })
      .catch((err) => {
        console.log(err);
        message.error(err.errorFields[0].errors[0]);
      });
  };
  useEffect(() => {
    base64Image = null;

    if (liveDetail) {
      setWaterMark(liveDetail.waterMark);
      setReplayFlag(liveDetail.replayFlag);
      const {
        firstCenterCategoryId,
        secondCenterCategoryId,
        firstSubjectId,
        secondSubjectId,
        thirdSubjectId,
        playCount,
        centerCategoryNameList,
        liveUrl,
        categoryId,
        startTime,
        endTime,
      } = liveDetail;
      const centerCategoryIdList = [
        firstCenterCategoryId,
        secondCenterCategoryId,
      ];
      const subjectIdList = [firstSubjectId, secondSubjectId, thirdSubjectId];
      console.log("subjectIdList", subjectIdList);
      const timeFormat = "YYYY-MM-DD HH-mm-ss";
      form.setFieldsValue({
        name: liveDetail.name,
        tagInfo: liveDetail.tagInfo,
        centerCategoryIdList,
        image: liveDetail.image,
        teacherIdList: liveDetail.teacherIdList,
        showOrder: liveDetail.showOrder,
        content: liveDetail.content,
        introduction: liveDetail.introduction,
        subjectIdList,
        categoryId,
        playCount,
        centerCategoryNameList,
        liveUrl,
        liveTime: [moment(startTime, timeFormat), moment(endTime, timeFormat)],
      });
      /**设置课程类型 */
      courseware.setFieldsValue({
        courseSectionList: liveDetail.courseSectionList,
      });

      originalImage = {
        shortUrl: liveDetail.originalImage,
        url: liveDetail.originalImageAllPath,
        initImage: liveDetail.imageAllPath,
      };
      setOriginalLogo(liveDetail.imageAllPath);

      // getBase64Image(liveDetail.originalImageAllPath).then((base) => {
      //   base64Image = base.data;
      //   if (originalImage) {
      //     originalImage.base64 = base.data;
      //   }
      //   setOriginalLogo(base.data);
      //   if (liveDetail.waterMark) {
      //     watermaskChange(true, base.data);
      //   }
      // });
    } else {
      setDefaultCourseImg();
    }
  }, []);
  /**
   * 设置默认图片
   */
  const setDefaultCourseImg = async () => {
    let {
      data: { originalImage: shortUrl, originalImageAllPath },
    } = await getCourseDefaultImg();
    originalImage = {
      shortUrl,
      url: originalImageAllPath,
      initImage: originalImageAllPath,
    };
    setOriginalLogo(originalImageAllPath);
  };
  return (
    <>
      <Modal
        title={liveDetail && liveDetail.id ? "编辑直播" : "新建直播"}
        width={980}
        visible={true}
        onOk={handleOk}
        onCancel={handleCancel}
        destroyOnClose={true}
      >
        <Form
          form={form}
          labelCol={labelCol}
          wrapperCol={wrapperCol}
          scrollToFirstError={true}
          initialValues={{
            questionnaireId: 0,
          }}
        >
          <Form.Item
            label="直播名称"
            name="name"
            rules={[
              {
                required: true,
                message: "请输入直播名称",
              },
            ]}
          >
            <Input
              onChange={onNameChange}
              placeholder="最多可输入100字"
              maxLength={100}
            />
          </Form.Item>
          <Form.Item
            label="直播分类"
            name="categoryId"
            rules={[
              {
                required: true,
                message: "请选择直播分类",
              },
            ]}
          >
            <Select>
              {treeData.map((item: any) => {
                return <Option value={item.key}>{item.title}</Option>;
              })}
            </Select>
          </Form.Item>
          <Form.Item
            label="直播时间"
            name="liveTime"
            rules={[
              {
                required: true,
                message: "请选择直播时间",
              },
            ]}
          >
            <RangePicker showTime />
          </Form.Item>
          <Form.Item
            name="liveUrl"
            label="直播地址"
            rules={[
              {
                required: true,
                message: "请输入直播地址",
              },
            ]}
          >
            <Input placeholder="请输入网址" maxLength={100} />
          </Form.Item>
          <Form.Item label="直播封面" name="image" valuePropName="fileList">
            <>
              <Input type="hidden" />
              {originalLogo && <img src={originalLogo} alt="" />}
              <Upload
                className="course-uploader"
                showUploadList={false}
                customRequest={uploadChange}
              >
                <p>* 支持2M以内JPG、PNG，请上传宽469px、高300px的图片</p>
                <Button>选择文件</Button>
              </Upload>
            </>
          </Form.Item>
          <Form.Item label="水印">
            <Switch
              checkedChildren="开启"
              unCheckedChildren="关闭"
              checked={waterMark}
              onChange={(checked) => {
                setWaterMark(checked);
                if (originalImage === null) return;

                if (checked) {
                  watermaskChangeBefore(checked);
                } else {
                  form.setFieldsValue({ image: originalImage.shortUrl });
                  getBase64Image(originalImage.url).then((base) => {
                    base64Image = base.data;
                    setOriginalLogo(base.data);
                  });
                }
              }}
            />
          </Form.Item>
          <Form.Item label="是否开启回放" valuePropName="replayFlag">
            <Switch
              checkedChildren="开启"
              unCheckedChildren="关闭"
              checked={replayFlag}
              onChange={(checked) => {
                setReplayFlag(checked);
              }}
            />
          </Form.Item>
          <Form.Item
            label="观看人次"
            name="playCount"
            rules={[
              {
                required: true,
                message: "请输入观看人次",
              },
            ]}
          >
            <InputNumber min={0} type="number" max={9999999999} />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};
